import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgPortfolioService } from '../../../../db/portfolio/portfolio.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'lib-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss'],
})
export class ContactCardComponent implements OnInit {
  private isLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<ContactCardComponent>,
    private portFolioService: NgPortfolioService
  ) {}

  ngOnInit() {}

  download(): void {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.portFolioService.get('download').subscribe((result) => {
      const { filePath, fileName } = result;

      try {
        fetch(filePath)
          .then((resp) => resp.blob())
          .then((blob) => {
            FileSaver.saveAs(blob, fileName);
          });
      } catch (e) {
        alert('에러가 발생 했습니다. 새로고침 후 다시 시도해주세요.');
      } finally {
        this.isLoading = false;
      }
    });
  }
}
